"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _Label = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("./utils");
var _validations = require("./validations");
var styles = {
  "check": "GrantTypes__check__jMbCS",
  "note": "GrantTypes__note__21Rgh",
  "grant-type": "GrantTypes__grant-type__1VNnv",
  "grantType": "GrantTypes__grant-type__1VNnv",
  "grant-type-info": "GrantTypes__grant-type-info__1Ms8j",
  "grantTypeInfo": "GrantTypes__grant-type-info__1Ms8j"
}; 
require('./GrantTypes.css');
var GrantTypes = function GrantTypes(_ref) {
  var form = _ref.form,
    grantTypes = _ref.grantTypes,
    isConfigurable = _ref.isConfigurable,
    identityManagementType = _ref.identityManagementType,
    isGrantTypesDirty = _ref.isGrantTypesDirty;
  var formWithGrantTypes = (0, _utils.mergeGrantTypes)(form, grantTypes);
  if (!grantTypes || grantTypes.length === 0) {
    return null;
  }
  var grantTypeValidator = (0, _validations.getGrantTypeValidator)({
    identityManagementType: identityManagementType
  })({
    grantTypes: grantTypes,
    form: formWithGrantTypes,
    isGrantTypesDirty: isGrantTypesDirty,
    isGrantTypesRequired: isConfigurable
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Label.default, null, "OAuth 2.0 Grant type"), !isConfigurable ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.note,
    "data-test-id": "not-configurable-message"
  }, "Grant types must be configured from your provider settings.") : null, /*#__PURE__*/_react.default.createElement("div", null, grantTypes.map(function (grantType, index) {
    var excludingGrantTypes = (0, _utils.getExcludingGrantTypes)(grantType, grantTypes, formWithGrantTypes);
    var isDependencyRequirementsValid = (0, _utils.checkDependencyRequirements)(grantType, formWithGrantTypes);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.grantType, {
        'visually-hidden': !isConfigurable
      }),
      key: "span-".concat(grantType.name)
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      testId: grantType.name,
      className: styles.check,
      key: grantType.name,
      name: (0, _utils.getGrantTypeValueKey)(grantType.name),
      label: grantType.label,
      disabled: formWithGrantTypes[(0, _utils.getGrantTypeDisabledKey)(grantType.name)],
      checked: formWithGrantTypes[(0, _utils.getGrantTypeValueKey)(grantType.name)],
      validate: index === 0 ? {
        grantTypeValidator: grantTypeValidator
      } : _validations.nullValidator
    }), excludingGrantTypes.length !== 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: styles.grantTypeInfo
    }, "(Excluded by", ' ', excludingGrantTypes.map(function (excludingGrantType) {
      return excludingGrantType.label;
    }).join(', '), ")") : null, excludingGrantTypes.length === 0 && !isDependencyRequirementsValid ? /*#__PURE__*/_react.default.createElement("span", {
      className: styles.grantTypeInfo
    }, "(Requires one of", ' ', (0, _utils.getDependencies)(grantType, grantTypes).map(function (dependency) {
      return dependency.label;
    }).join(', '), ")") : null);
  })));
};
var _default = exports.default = GrantTypes;
//# sourceMappingURL=GrantTypes.js.map